import { UtilisateurRole } from '@common/services';

export const USER_ROLE_TEXTS: Record<UtilisateurRole | unknown, string> = {
  [UtilisateurRole.REPRESENTANT]: 'Représentant légal',
  [UtilisateurRole.ADMIN_1]: 'Administrateur',
  [UtilisateurRole.ADMIN_2]: 'Administrateur (2e)',
  [UtilisateurRole.DELEGATAIRE]: 'Délégataire',
  [UtilisateurRole.DEMANDEUR]: 'Demandeur',
  [UtilisateurRole.SIMPLE]: 'Utilisateur',
  FC: 'France compétences',
  IAM: 'IAM',
  ANONYMOUS: 'Anonyme',
  SYSTEM: 'Système',
  INCONNU: 'Inconnu',
};